import { FormGroup } from '@angular/forms';
import { AssignorFormAccount, AssignorRequestAccount } from './accounts.model';
import { AssignorAgents } from './agents.model';
import { Fund, ReducedFundData } from './fund.model';
import { AssignorGuarantors } from './guarantors.model';
import { Pagination, PaginationForm } from './pagination.model';
import { SelectData } from './select-input.model';
import { AssignorStakeHolder } from './stakeholders.model';
import { ModelForm } from './form-helpers.model';

export interface Assignor {
  id: string;
  nome: string;
  cnpjcpf: string;
  status: number;
  dataCriacao: string;
  cadastro: number;
  compliance: number;
  fundo: ReducedFundData;
  gestora: number;
  versao: number;
  prcAdcCadastro: number;
  prcAdcCompliance: number;
  prcAdcGestora: number;
  cnpjCedente?: string;
  nomeCedente?: string;
}

export interface AssignorMinimal {
  id: number,
  nome: string,
  cnpj: string
}

export interface AssignorPaged extends Pagination {
  cedentes: Assignor[];
}

export interface AssignorSummary {
  ATIVO: number;
  FORMALIZACAO: number;
  REPROVADO: number;
  PENDENCIADO: number;
  ANALISE: number;
}

export interface AssignorCreationFields {
  id?: number;
  nome: string;
  cnpjcpf: string;
  inscricaoEstadual: string;
  inscricaoMunicipal: string;
  email: string;
  inicioRelacionamento: Date;
  terminoRelacionamento: Date;
  faturamentoAnual: string;
  autorizacao: boolean;
  endereco: string;
  numero: string;
  complemento: string;
  cep: string;
  bairro: string;
  cidade: string;
  telefoneDDD: string;
  faxDDD: string;
  conglomeradoEconomico: string;
  numMinAssinaturasAprovacao: string;
  limiteCredito: string;
  cedenteBloqueado: boolean;
  recuperacaoJudicial: boolean;
  alteradoPor: string;
  origemCadastro: string;
  origemAlteracao: string;
  dataCadastro: Date;
  dataUltimaAlteracao: Date;
  operaSacadoSemRisco: boolean;
  permiteContaCorrenteSemDados: boolean;
  instituicaoFinanceira: boolean;
  ativaRepresentanteConsultoria: boolean;
  codigoCNAE: string;
  dividaUniao: boolean;
  chavePix: string;
  dadosBancarios: AssignorRequestAccount[];
  representantes: AssignorAgents[];
  avalistas: AssignorGuarantors[];
  partesRelacionadas: AssignorStakeHolder[];
}

export interface AssignorCreationFormFields extends AssignorCreationFields {
  tipoPessoa: string;
  porte: SelectData;
  classificacaoRisco: SelectData;
  tipoSociedade: SelectData;
  ramoAtividade: SelectData;
  tipoChavePix: SelectData;
  uf: SelectData;
  tipoControleCedente: SelectData;
  fundo: SelectData;
  tipoCoobrigacao: SelectData;
  dadosBancariosForm: AssignorFormAccount[];
}

export interface AssignorCreationRequestFields extends AssignorCreationFields {
  tipoPessoa: boolean;
  porte: string;
  classificacaoRisco: string;
  tipoSociedade: string;
  ramoAtividade: string;
  tipoChavePix: string;
  uf: string;
  tipoControleCedente: string;
  fundo: ReducedFundData;
  origemAlteracao: string;
  justificativaBloqueio: string;
  formaBloqueio: string;
  nomeUsuario: string;
}


export interface AssignorFilter {
  cnpjFundo: SelectData;
  nomeCedente: string;
  cnpjCedente: string;
  filtroFundo?: boolean;
  filtroNome?: boolean;
  filtroCnpj?: boolean;
}

export interface AssignorsSearchParams {
  fundos?: ReducedFundData[];
  nomes?: string[];
  cnpjs?: string[];
}

export interface AssignorFilterForm extends AssignorFilter {
  paginator: FormGroup<ModelForm<PaginationForm>>;
}

export interface AssignorFilterValue extends AssignorFilter {
  paginator: PaginationForm;
}
